import React , {Component} from 'react'
import '../Cards/card.css'
import ReactDOM from 'react-dom';
import Cookies from 'universal-cookie';
import {Link,NavLink} from 'react-router-dom'
import $ from 'jquery';
import unSave from '../../assets/icons/save.png'
import Save from '../../assets/icons/unsave.png'
import SigninPopup from '../SignInPopup/SigninPopup';
import axios from 'axios';
import { LazyLoadImage } from 'react-lazy-load-image-component';

window.$ = $;

const cookies = new Cookies();

class Card extends Component{
    constructor(props){
        super(props);
        this.state = {
            data: [],
            expanded: false,
           showTitles: false,
           saveCount: props.saveCount,
           showPopup: false,
       };
    }
    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside, true);
    }
    
    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside, true);
    }
    handleClickOutside = event => {
        const domNode = ReactDOM.findDOMNode(this);
        if (!domNode || !domNode.contains(event.target)) {
            this.setState({
                showPopup: false
            });
        }
    }
    toggle = (pid) => {
    
        document.addEventListener('click', this.handleClickOutside, true);
       
        if(cookies.get("domain") == "SelectFashion") {
            var userID = cookies.get("usfid");
            var cat = {
                "productID":pid,
	            "userID":userID
               }
               this.setState({expanded: !this.state.expanded , saveCount: this.state.saveCount + 1})

          axios.post(`https://selectabe20190603082437.azurewebsites.net/api/saved/AddSaveProduct`, cat,
        { headers: {Origin:"http://localhost:3000",Host: "http://localhost:55414"} }).then((response)=>{
            let res = JSON.parse(JSON.stringify(response));
            if (res.statusText === "OK") {
            } else {
                alert("something went wrong");
            }
        })
            }

            else{
                this.setState({showPopup: true})
            }
       
    };
    toggleSaveCounter = (pid) => {

        var userID = cookies.get("usfid");
            var cat = {
                "productID":pid,
	            "userID":userID
               }
               this.setState({expanded: !this.state.expanded , saveCount: this.state.saveCount - 1});

        axios.post(`https://selectabe20190603082437.azurewebsites.net/api/saved/DeleteSaveProduct`, cat,
        { headers: {Origin:"http://localhost:3000",Host: "http://localhost:55414"} }).then((response)=>{
            let res = JSON.parse(JSON.stringify(response));
            if (res.statusText === "OK") {
            } else {
                alert("something went wrong");
            }
        })

        
    };


    componentDidMount() {
        
      }
       data =  { "pageNumber": 1,
       "pageSize": 24,
       "filter":
      { "Color": [], 
        "Brand": [], 
         "FabricType": [], 
          "Design": [], 
          "DupattaType": [],
          "DressType": [],
          "Price": []
         
      } };
       
      ab = ()=> {
         return "item/"+ "id=" + this.props.id
      }
      brand = ()=> {
        return "/" + this.props.title
     }
      expand = ()=> {
        this.setState({expanded: !this.state.expanded})
     }
    
    render(){ 
        return(
        
           <li className="product-item">
          <div className="brandDetails">
          <Link to={this.brand()} className="brandName" style={{color: "#365899"}}>{this.props.title}</Link>
          </div>
          
          <NavLink className="url" to={this.ab()}>
          <div className="product-image">
          {/* <img className="image" src={this.props.image}></img> */}
          <LazyLoadImage
            className="image"
            alt={this.props.title +" "+ this.props.header}
            effect="blur"
            src={this.props.image}  />
          <span className="sprice-tag"  style={{display: `${this.props.sale ? "": 'none'}`}}>{this.props.saleper}% Off</span>
          </div>
          </NavLink>
          <div className="product-item-detail">
          <h4 className="price"><span className="currency">{this.props.currencyRS}</span>{this.props.price}{this.props.currency}</h4>
          <span className="arrow_wrapper" onClick={() => this.toggleSaveCounter(this.props.id)} style={{display: `${this.state.expanded ? "": 'none'}`}}>
          <img className="saveProduct" src={Save}  />
          </span>
         <span className="arrow_wrapper" onLoad={this.props.flag == 1 ?this.expand:null} onClick={() => this.toggle(this.props.id)} style={{display: `${this.state.expanded? "none": ''}`}}>
         <img className="saveProduct" src={unSave}/>
         </span>
         <span className="totalSave"><span>(<span>{this.state.saveCount}</span>)</span></span>
         <div className="underSave" style={{display: `${this.state.showPopup? "": 'none'}`}}>
             <SigninPopup />
         </div>
          </div>
        </li>
        )}}
       
        export default Card;